export { ViewEmailComponent } from './view-email/view-email.component';
export { ViewNameComponent } from './view-name/view-name.component';
export { ViewNickNameComponent } from './view-nick-name/view-nick-name.component';
export { ViewPhoneComponent } from './view-phone/view-phone.component';
export { ViewPinComponent } from './view-pin/view-pin.component';
export { ViewAddressesComponent } from './view-addresses/view-addresses.component';